import '../style.scss';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { useInvoice } from './hooks';
import { TemplateProps } from '../common';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { InputInvoice } from 'views/mutual/invoice';

export type CorporateInvoiceProps = {
  formik: any;
  invoiceNumberProps: any;
};

export const InvoiceWrapper = () => {
  return <CorporateInvoice {...useInvoice({ isUpdate: false })} />;
};

export const CorporateInvoice = ({
  formik,
  invoiceNumberProps,  
  isUpdate,
}: CorporateInvoiceProps & TemplateProps) => {
  useCustomLocationName('口座開設申込みフォーム');

  return (
    <form onSubmit={formik.handleSubmit} className="accountOpenTemplate">
      <div className="accountOpenTemplate_input">
          <FormContentHeader label="インボイス番号" formType={FormType.Optional} />
          <InputInvoice {...invoiceNumberProps} />
      </div>
    </form>
  );
};
